import React from "react";
import designImg from "../../../assets/IMG_5480.png";

const Design = () => {
  return (
    <div className="design pt-[50px] pb-[100px]">
      <div className="container mx-auto">
        <div className="card rounded-xl shadow-2xl p-4">
          <div className="flex lg:flex-row flex-col justify-between items-center gap-10">
            <div className="w-full lg:w-[45%] lg:ps-[50px]">
              <p
                className="uppercase text-sm font-semibold"
                style={{ letterSpacing: 1 }}
              >
                design
              </p>
              <h2
                className="text-[40px] font-bold mt-1"
                style={{ lineHeight: "1.2" }}
              >
                We <span className="besley font-normal italic">stylize </span>{" "}
                each AR-QR code to your brand
              </h2>
              <p className="text-lg mt-4">
                We use your design brand book to style each of our codes to suit
                your brand identity.
              </p>
            </div>
            <div className="w-full lg:w-[50%]">
              <img src={designImg} alt="" />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Design;
